import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import Home from '../components/ai/Home';
import Process from '../components/ai/Process';

const AiBattle = () => (
  <div>
    <Routes>
      {/* Default route inside /user */}
      <Route path="/" element={<Navigate to="home" replace />} />
      {/* Route for Home */}
      <Route path="home" element={<Home />} />
      <Route path="process" element={<Process />} />
    </Routes>
  </div>
);

export default AiBattle;
